import { useSiteContext } from "../../../../context/siteContext";
import { Typography } from "@mui/joy";
import React, { useState } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { QuillEditor } from "../../../../components/QuillEditor";
import useApiService from "../../../../hooks/useApiService";
import { Site } from "../../../../models/site.interface";

function SummaryScopeOfWork() {
  const { site, setSite } = useSiteContext();
  const [modalToShow, setModalSoShow] = useState<"scope-of-work" | null>(null);
  const [scopeOfWork, setScopeOfWork] = useState(site?.scope_of_work || "");

  const { loading: updatingSite, fetchData: updateSite } = useApiService<Site>({
    method: "PUT",
    url: `site-list/${site?.id}`,
    apiName: "core",
    fetchOnMount: false,
    onSuccess: data => {
      console.log("Scope of work updated", data);
      setSite(data);
      // update site context
      // setSite((prev: any) => ({ ...prev, scope_of_work: data.scope_of_work }));
      setModalSoShow(null);
    },
  });

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography level="h2" component="h1">
          Summary Scope of Work: {site?.name}
        </Typography>
        <Button
          label={"Edit"}
          color={"secondary"}
          outlined={true}
          icon={"pi pi-pencil"}
          onClick={() => setModalSoShow("scope-of-work")}
        />
      </div>

      <div dangerouslySetInnerHTML={{ __html: `${site?.scope_of_work}` }} />

      <Dialog
        onHide={() => setModalSoShow(null)}
        header={"Scope of Work"}
        visible={modalToShow === "scope-of-work"}
        style={{ width: "80vw", minWidth: 1240, height: "85vh" }}
      >
        <div
          style={{ height: "100%", position: "relative", display: "flex", flexDirection: "column" }}
        >
          <div className={"my-4"}>
            <QuillEditor
              label={"Scope of Work"}
              setContent={val => {
                setScopeOfWork(val);
              }}
              content={scopeOfWork}
              heightPx={42}
            />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              gap: "1rem",
              background: "white",
              flexShrink: 0,
            }}
          >
            <Button
              label="Cancel"
              severity="secondary"
              outlined
              disabled={updatingSite}
              onClick={() => {
                setScopeOfWork(site?.scope_of_work || "");
                setModalSoShow(null);
              }}
            />
            <Button
              label={"Update"}
              color={"primary"}
              loading={updatingSite}
              disabled={updatingSite}
              onClick={async () => {
                let payload = {
                  ...site,
                  scope_of_work: scopeOfWork,
                };

                delete payload.industry_list;
                delete payload.job_task_list;
                delete payload.updated_at;
                delete payload.created_at;
                delete payload.deleted_at;
                delete payload.setup_complete;
                delete payload.badge;

                await updateSite({
                  payload,
                });
              }}
            />
          </div>
        </div>
      </Dialog>
    </>
  );
}

export default SummaryScopeOfWork;
